/* You can add your custom scripts here */

$(document).ready(function() {
    // Loop through each 'li' element
    $('.product-option-picker__list li').each(function(index) {
      // Remove 'active' class from all 'product_variant_price' spans within the 'li'
      $(this).find('.product_variant_price').removeClass('active');
      $(this).find('.product_variant_compare_price').removeClass('active');
      $(this).find('.price-wrap').removeClass('active');
      
      // Add 'active' class to the appropriate 'product_variant_price' span based on the index
      $(this).find('.product_variant_price:eq(' + index + ')').addClass('active');
      $(this).find('.product_variant_compare_price:eq(' + index + ')').addClass('active');
      $(this).find('.price-wrap:eq(' + index + ')').addClass('active');

      /* metafield */
      $(this).find(".main").removeClass("active");
      $(this).find('.main:eq(' + index + ')').addClass('active');
      
    });
  });